import AttachmentDataProviderItem from 'owa-service/lib/contract/AttachmentDataProviderItem';
import AttachmentDataProviderItemType from 'owa-service/lib/contract/AttachmentDataProviderItemType';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import GetAttachmentDataProviderItemsResponse from 'owa-service/lib/contract/GetAttachmentDataProviderItemsResponse';
import handleGetItemsResponse from './handleGetItemsResponse';
import Message from 'owa-service/lib/contract/Message';
import { getMailMessageItems } from 'owa-fileprovider-services';
import {
    createAttachmentDataProviderItemsResponse,
    createFailedAttachmentDataProviderItemsResponse,
} from './createAttachmentDataProviderItemsResponse';

export interface MailMessageDataProviderItem extends AttachmentDataProviderItem {
    MessagePreview: string;
    IsRead: boolean; //VSO #33068 Display unread mail messages
}

function getMessageSender(item: Message) {
    if (item.From?.Mailbox) {
        return item.From.Mailbox.Name;
    } else {
        return null;
    }
}

function createAttachmentDataProviderItem(item: Message): MailMessageDataProviderItem {
    return {
        __type: item.__type,
        Id: item.ItemId.Id,
        AttachmentProviderId: null,
        ProviderType: AttachmentDataProviderType.MailMessage,
        Type: AttachmentDataProviderItemType.File,
        Size: item.Size,
        From: getMessageSender(item),
        Subject: item.Subject,
        ReceivedDate: item.DateTimeSent,
        MessagePreview: item.Preview,
        IsRead: item.IsRead,
    };
}

export const createResponseFunc = (items: Message[]) =>
    createAttachmentDataProviderItemsResponse(items, createAttachmentDataProviderItem);

export default async function getMailMessageFileProviderItems(
    folderId: string,
    offset: number
): Promise<GetAttachmentDataProviderItemsResponse> {
    const { errorResponse, result } = await getMailMessageItems(folderId, offset);

    if (result) {
        return handleGetItemsResponse(
            result,
            null /* errorResponse */,
            createResponseFunc,
            createFailedAttachmentDataProviderItemsResponse
        );
    } else {
        return handleGetItemsResponse(
            null /* result */,
            errorResponse,
            createResponseFunc,
            createFailedAttachmentDataProviderItemsResponse
        );
    }
}
